<template>
  <div class="kydt">
    <div class="title1" v-show="showList">科研团队</div>
    <div v-if="showList">
      <div v-for="(x, index) in titleList" :key="x.column_id">
        <div class="tab-btn clearfix" :class="{ 'tab-btn-active': selectIndex == index }" @click="handleSelect(index)">
          <!-- <div class="label">{{ x.title1 }}</div> -->
          <div class="text">{{ x.title2 }}</div>
        </div>

      </div>

      <div class="item">
        <div v-show="selectIndex == 0">
          <div v-for="(y, index) in titleList[0].children" :key="index">
            <div class="team-sub">{{ y.title }}</div>
            <listUser ref="listUser" @detail="detail" :columnId="y.column_id"></listUser>
          </div>
        </div>
        <div v-show="selectIndex == 1">
          <div v-for="(y, index) in titleList[1].children" :key="index">
            <div class="team-sub">{{ y.title }}</div>
            <listUser ref="listUser" @detail="detail" :columnId="y.column_id"></listUser>
          </div>
        </div>
        <div v-show="selectIndex == 2">
          <div v-for="(y, index) in titleList[2].children" :key="index">
            <div class="team-sub">{{ y.title }}</div>
            <listUser ref="listUser" @detail="detail" :columnId="y.column_id"></listUser>
          </div>
        </div>
        <div v-show="selectIndex == 3">
          <div v-for="(y, index) in titleList[3].children" :key="index">
            <div class="team-sub">{{ y.title }}</div>
            <listUser ref="listUser" @detail="detail" :columnId="y.column_id"></listUser>
          </div>
        </div>
        <div v-show="selectIndex == 4">
          <div v-for="(y, index) in titleList[4].children" :key="index">
            <div class="team-sub">{{ y.title }}</div>
            <listUser ref="listUser" @detail="detail" :columnId="y.column_id"></listUser>
          </div>
        </div>
      </div>



    </div>
    <detailVue :articleId="article_id" v-if="!showList"></detailVue>
  </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
import listUser from '../../components/listUser.vue';
export default {
  components: {
    listUser,
    detailVue
  },
  data() {
    return {
      showList: true,
      column_id: '',
      article_id: '',
      titleList: [
        {
          column_id: "755828939740004352",
          title1: "团队一",
          title2: "水产南繁种质创新中心",
          children: [
            {
              column_id: "753631520449216512",
              title: "首席科学家",
            },
            {
              column_id: "753631613814423552",
              title: "热带经济生物分子育种与健康育苗团队",
            },
            {
              column_id: "753631718109986816",
              title: "热带名贵水产动物繁育与产业化应用团队",
            },
            {
              column_id: "753631808367214592",
              title: "热带设施渔业工程与制种技术研究团队",
            },
            {
              column_id: "753631899777875968",
              title: "观赏水生动物资源保护与繁育团队",
            },
          ]
        },
        {
          column_id: "755829515831853056",
          title1: "团队二",
          title2: "热带海洋生态与蓝碳中心",
          children: [
            {
              column_id: "753632041650208768",
              title: "首席科学家",
            },
            {
              column_id: "753632131752247296",
              title: "海陆统筹污染防控与生态修复研究团队",
            },
            {
              column_id: "753632220889595904",
              title: "海洋生态毒理研究团队",
            },
            {
              column_id: "753632304628875264",
              title: "海洋碳汇研究团队",
            },
            {
              column_id: "753632390800850944",
              title: "珊瑚礁生态研究团队",
            },
            {
              column_id: "753632471352459264",
              title: "海草床生态研究团队",
            },
          ]
        },
        {
          column_id: "755829598107320320",
          title1: "团队三",
          title2: "深海探测与装备中心",
          children: [
            {
              column_id: "753632566345056256",
              title: "首席科学家",
            },
            {
              column_id: "753632645822922752",
              title: "海洋与海岸动力过程团队",
            },
            {
              column_id: "753632722394136576",
              title: "海洋地质灾害与环境化学团队",
            },
            {
              column_id: "753632799682576384",
              title: "海洋功能材料团队",
            },
            {
              column_id: "753632873842065408",
              title: "海洋装备研发团队",
            },
            {
              column_id: "838437469125173248",
              title: "海洋环境与资源遥感团队",
            },
          ]
        },
        {
          column_id: "755829666545778688",
          title1: "团队四",
          title2: "智能试验场与数字南海中心",
          children: [
            {
              column_id: "753632953823248384",
              title: "首席科学家",
            },
            {
              column_id: "753633035897389056",
              title: "智能应用场团队",
            },
            {
              column_id: "753633115660468224",
              title: "海洋遥感与数字南海团队",
            },
          ]
        },
        {
          column_id: "952133107531997184",
          title1: "团队五",
          title2: "南海资源开发与工程环境研究所",
          children: [
            {
              column_id: "952133366257639424",
              title: "首席科学家",
            },
            {
              column_id: "952133452995846144",
              title: "海洋环境工程团队",
            },
            // {
            //   column_id: "753633115660468224",
            //   title: "海洋遥感与数字南海团队",
            // },
          ]
        },
      ],
      selectIndex: 0,
      userArr: []
    }
  },
  created() {
    // this.column_id = this.$route.query.column_id
    // this.getList()

  },
  beforeDestroy() {
    // 在组件销毁前，移除 popstate 事件监听
    window.removeEventListener('popstate', this.onPopState)
  },
  mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
    this.handleSelect(0)
  },
  methods: {
    onPopState(e) {
      if (this.showList == false) {
        this.showList = true
        // window.history.pushState(null, null, window.location.href)
      } else {
        window.removeEventListener('popstate', this.onPopState)
        //  window.history.go(-1)
        this.$router.replace({ path: '/' })
      }
    },
    detail(item) {
      if (item.redirection_address) {
        window.open(item.redirection_address);
      } else {
        this.article_id = item.article_id
        this.showList = false
      }
    },
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: "755827561772728320",
        // pageNo:self.currentPage,
        // pageCount:self.pageSize
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            // self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    handleSelect(index) {
      // this.userArr = []
      this.selectIndex = index

    }
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
      this.showList = true
    }
  }
};
</script>

<style lang="less" scoped>
.kydt {
  padding: 0 30px;

  // overflow: auto;
  .team-tit {
    height: 44px;
    line-height: 44px;
    background: #efefef;
    margin: 10px 0;

    .label {
      float: left;
      width: 70px;
      text-align: center;
      background: #0163ac;
      color: #fff;
      margin-right: 20px;
    }

    .text {
      float: left;
      font-size: 16px;
    }
  }


  .team-sub {
    font-size: 16px;
    color: #cc0000;
  }

  .tab-btn {
    width: 20%;
    float: left;
    box-sizing: border-box;
    margin: 30px 0;
    padding: 15px 0;
    cursor: pointer;
    background: #dedede;
    text-align: center;
    .text{
      white-space: nowrap;
    }
  }

  .tab-btn-active {
    background: #0163ac;
    color: #fff;
  }

  .title1 {
    text-align: center;
    font-size: 22px;
    margin: 10px 0 30px;
  }
}

@media screen and (max-width: 1025px) {
  .kydt {
    padding: 0;

    .tab-btn {
      margin: 2px;
      width: 48%;
      padding: 7px 0;
      font-size: 12px;

    }

    .item {
      padding-top: 80px;
    }

  }
}
</style>